import { render } from "./ModalVideo.vue?vue&type=template&id=64243fe0&ts=true"
import script from "./ModalVideo.vue?vue&type=script&scoped=true&lang=ts"
export * from "./ModalVideo.vue?vue&type=script&scoped=true&lang=ts"

import "./ModalVideo.vue?vue&type=style&index=0&id=64243fe0&lang=css"

import exportComponent from "/var/www/html/devcwmserver.com/taca/client/staging/RACA_FRONTEND/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__